import e from"react";const r=()=>e.createElement("hr",{className:"h-[5px] max-w-[1280px] border-none bg-rainbow-gradient"});export{r as default};
